module.exports = __webpack_public_path__ + "resources/img/sp_radio.537e5bbe9ec93dae91258ca02698ec79.png";